<template>
  <div>
    <div v-if="loading">
      Loading...
    </div>
    <slot v-if="loaded" />
    <slot name="fulfilled" v-if="loaded" />
    <div v-if="error">Error: {{error.response.data.message}}</div>
  </div>
</template>

<script>
export default {
  props: ['loadingPromise'],
  data() {
    return {
      loading: false,
      loaded: false,
      error: null,
    }
  },
  mounted() {
    this.checkLoading()
  },
  methods: {
    checkLoading() {
      if (this.loadingPromise) {
        this.loading = true
        this.loadingPromise.then(() => {
          this.loaded = true
        }).catch(error => {
          this.error = error
        }).then(() => {
          this.loading = false
        })
      }
    }
  },
  watch: {
    loadingPromise() {
      this.checkLoading()
    },
  },
}
</script>

<style lang="stylus" scoped>

</style>
